import {
    CAP_SERVICE_GROUPS_LOADED, CAP_SERVICE_GROUPS_LOADING
} from "../../actions/actionTypes";

const initialState = {
    capServiceGroups: null,
    loading: false,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case CAP_SERVICE_GROUPS_LOADING:
            return {
                ...state,
                loading: true
            };
        case CAP_SERVICE_GROUPS_LOADED:
            return {
                ...state,
                capServiceGroups: action.payload,
                loading: false
            };
        default:
            return state;
    }
}